module.exports = __webpack_public_path__ + "static/img/iphone_ldt2_back.78c6d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldt2_back.png
// module id = 8jod
// module chunks = 0